// src/form.ts
import { observeAttributes } from "@zag-js/mutation-observer";
function getClosestForm(el) {
  if (isFormElement(el))
    return el.form;
  else
    return el.closest("form");
}
function isFormElement(el) {
  return el.matches("textarea, input, select, button");
}
function trackFormReset(el, callback) {
  if (!el)
    return;
  const form = getClosestForm(el);
  form?.addEventListener("reset", callback, { passive: true });
  return () => {
    form?.removeEventListener("reset", callback);
  };
}
function trackFieldsetDisabled(el, callback) {
  const fieldset = el?.closest("fieldset");
  if (!fieldset)
    return;
  callback(fieldset.disabled);
  return observeAttributes(fieldset, ["disabled"], () => callback(fieldset.disabled));
}
function isNativeDisabled(el) {
  return el.matches(":disabled");
}
function trackFormControl(el, options) {
  if (!el)
    return;
  const { onFieldsetDisabled, onFormReset } = options;
  const cleanups = [
    trackFormReset(el, onFormReset),
    trackFieldsetDisabled(el, (disabled) => {
      if (disabled)
        onFieldsetDisabled();
    })
  ];
  return () => {
    cleanups.forEach((cleanup) => cleanup?.());
  };
}

export {
  getClosestForm,
  isNativeDisabled,
  trackFormControl
};
